<template>
    <div class="editform">
        <Form
            ref="workOrderDetail"
            :model="workOrderForm"
            :label-width="70"
            :viewonly="isView"
        >
            <Row>
                <FormPartition title="基本信息">
                    <Row :gutter="20">
                        <Col span="12">
                            <FormItem label="工单号" prop="code">
                                <Input
                                    v-model="workOrderForm.code"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="工单状态" prop="statusText">
                                <Input
                                    v-model="workOrderForm.statusText"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="服务类型" prop="serviceTypeText">
                                <Input
                                    v-model="workOrderForm.serviceTypeText"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem
                                label="业务类别"
                                prop="serviceCategoryText"
                            >
                                <Input
                                    v-model="workOrderForm.serviceCategoryText"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="预约时间" prop="datePeriodText">
                                <Input
                                    v-model="workOrderForm.datePeriodText"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="房源名称" prop="houseName">
                                <Input
                                    v-model="workOrderForm.houseName"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="20">
                            <FormItem label="内容描述" prop="content">
                                <Input
                                    v-model="workOrderForm.content"
                                    :maxlength="32"
                                    type="textarea"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="相关照片" prop="attachments">
                                <div style="display: flex">
                                    <previewUpload
                                        v-model="workOrderForm.attachments"
                                    />
                                </div>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem
                                label="提交对象"
                                prop="submitIdentityText"
                            >
                                <Input
                                    v-model="workOrderForm.submitIdentityText"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="提交人" prop="createUserName">
                                <Input
                                    v-model="workOrderForm.createUserName"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem
                                label="提交人电话"
                                prop="createUserMobile"
                            >
                                <Input
                                    v-model="workOrderForm.createUserMobile"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="提交时间" prop="createTime">
                                <Input
                                    v-model="workOrderForm.createTimeText"
                                    :maxlength="32"
                                >
                                </Input>
                            </FormItem>
                        </Col>
                    </Row>
                </FormPartition>

                <FormPartition title="派单信息">
                    <Row :gutter="20">
                        <Col span="12">
                            <FormItem label="实施地址" prop="address">
                                <Input
                                    v-model="workOrderForm.address"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="20">
                            <FormItem label="补充描述" prop="remark">
                                <Input
                                    v-model="workOrderForm.remark"
                                    :maxlength="32"
                                    type="textarea"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="委派类型" prop="dispatchType">
                                <Input
                                    v-model="workOrderForm.dispatchTypeText"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="派单人" prop="dispatchUserName">
                                <Input
                                    v-model="workOrderForm.dispatchUserName"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem
                                label="派单人电话"
                                prop="dispatchUserMobile"
                            >
                                <Input
                                    v-model="workOrderForm.dispatchUserMobile"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="派单时间" prop="dispatchTimeText">
                                <Input
                                    v-model="workOrderForm.dispatchTimeText"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="联系人" prop="contactName">
                                <Input
                                    v-model="workOrderForm.contactName"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="联系电话" prop="contactMobile">
                                <Input
                                    v-model="workOrderForm.contactMobile"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </FormPartition>
            </Row>
        </Form>
    </div>
</template>

<script>
import Dict from '_u/dict'
import { ymdL } from '@/utils/helper'

export default {
    name: 'orderForm',
    props: {
        id: {
            type: [String],
            default: '',
        },
        workOrderEntity: {
            type: [Object],
            default: () => {},
        },
    },
    data: () => {
        return {
            loading: false,
            isView: true,
            modalHeight: 600,
            modalWidth: 1000,
            workOrderForm: {
                code: '',
                status: '',
                serviceType: '',
                serviceCategory: '',
                appointmentDate: '',
                houseName: '',
                content: '',
                attachments: '',
                createUserName: '',
                createUserMobile: '',
                createTime: '',
                createTimeText: '',
                address: '',
                remark: '',
                dispatchType: '',
                dispatchTypeText: '',
                dispatchTime: '',
                dispatchTimeText: '',
                dispatchUserName: '',
                dispatchUserMobile: '',
                contactName: '',
                contactMobile: '',
                appointmentPeriod: '',
                statusText: '',
                serviceTypeText: '',
                serviceCategoryText: '',
                datePeriodText: '',
                submitIdentity: '',
                submitIdentityText: '',
            },
            dict: {
                keepCleanCategory: Dict.NULL,
                repairCategory: Dict.NULL,
            },
        }
    },
    methods: {
        getServiceCategoryText(type, category) {
            //由于服务类别存储在两个词典中，因此需要根据服务类型判断使用哪个词典进行词典名称的获取
            var resultText = '未知'
            if (type == 'keepClean') {
                resultText = this.dict.keepCleanCategory.get(category).text
            }

            if (type == 'repair') {
                resultText = this.dict.repairCategory.get(category).text
            }

            return resultText
        },
        getAppointDateAndPeriod(date, period, appointmentPeriod) {
            var resultStr = '未知'
            resultStr = ymdL(date) + ' ' + appointmentPeriod.get(period).text
            return resultStr
        },
    },
    created() {
        Promise.all([
            Dict.get('dispatch_type'),
            Dict.get('reserve_time'),
            Dict.get('repair_category'),
            Dict.get('keep_clean_category'),
            Dict.get('service_type'),
            Dict.get('wo_action_type'),
        ])
            .then((args) => {
                var [
                    dispatchType,
                    appointmentPeriod,
                    repairCategory,
                    keepCleanCategory,
                    serviceType,
                    workOrderStatus,
                ] = args

                var entity = this.workOrderEntity

                Object.keys(this.workOrderForm).forEach(
                    (name) => (this.workOrderForm[name] = entity[name] || '')
                )
                this.dict.repairCategory = repairCategory
                this.dict.keepCleanCategory = keepCleanCategory
                //词典翻译
                this.workOrderForm.statusText = workOrderStatus.get(
                    this.workOrderForm.status
                ).text
                this.workOrderForm.serviceTypeText = serviceType.get(
                    this.workOrderForm.serviceType
                ).text
                this.workOrderForm.serviceCategoryText =
                    this.getServiceCategoryText(
                        this.workOrderForm.serviceType,
                        this.workOrderForm.serviceCategory
                    )

                this.workOrderForm.datePeriodText =
                    this.getAppointDateAndPeriod(
                        this.workOrderForm.appointmentDate,
                        this.workOrderForm.appointmentPeriod,
                        appointmentPeriod
                    )

                this.workOrderForm.createTimeText = ymdL(
                    this.workOrderForm.createTime
                )
                this.workOrderForm.dispatchTimeText = ymdL(
                    this.workOrderForm.dispatchTime
                )
                this.workOrderForm.dispatchTypeText = dispatchType.get(
                    this.workOrderForm.dispatchType
                ).text

                var map = new Map()
                map.set('1', '租客')
                map.set('2', '房东')
                this.workOrderForm.submitIdentityText = map.get(
                    this.workOrderForm.submitIdentity
                )
            })
            .finally(() => {
                this.loading = false
            })
    },
    mounted() {},
}
</script>
